import request from '../../http/request'
export const getSendList = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v2/api/nfc/tag/list/FULL`, params)
}

export const reSendNfcUid = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc-ant-service/tag/report/retryBinding`, params, {
    reSend: true
  })
}
export const getSendTotal = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v2/api/nfc/tag/summary/FULL`, params)
}
export const getProductAndSize = params => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc/v2/api/pmd/skuAndSizeDictionaries`, {
    params
  })
}
export const getNspExport = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v2/api/nfc/tag/export/FULL`, params, {
    responseType: 'blob',
    uploadOrDownload: true
  })
}

export const getSKUExport = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v1/api/sku/export`, params, {
    responseType: 'blob',
    uploadOrDownload: true
  })
}

export const getSKUHistoryExport = params => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc/v1/api/sku/history/export`, {
    params,
    responseType: 'blob',
    uploadOrDownload: true
  })
}

export const getSKUDisableExport = params => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc/v1/api/sku/last/disable/export`, {
    params,
    responseType: 'blob',
    uploadOrDownload: true
  })
}

export const getTagReportExport = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v2/api/tag/report/export`, params, {
    responseType: 'blob',
    uploadOrDownload: true
  })
}

export const getAllInactiveSkuExport = params => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc/v1/api/sku/all/disable/export`, {
    params,
    responseType: 'blob',
    uploadOrDownload: true
  })
}

export const getLatestActiveSkuList = params => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc/v1/api/sku/latest/active/export`, {
    params,
    responseType: 'blob',
    uploadOrDownload: true
  })
}
